import React from 'react'
import { graphql} from 'gatsby'
import { PrismicRichText} from '@prismicio/react'
import * as prismicH from '@prismicio/helpers'
import Layout from '@layout'
import SEO from '@layout/SEO'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import OtherOptionsMenu from '@components/OtherOptionsMenu'
import ItemsList from './ItemsList'
import ContentGrid from '@components/ContentGrid'

export const query = graphql `
query ContentCategoryQuery ($uid: String)
{
  allPrismicContentCategoryLandingPage(filter: { uid: { eq: $uid }}){
    edges {
      node {
        _previewable
        uid
       url
        data {
          content_category
          content_description {
            text
            html
            raw
          }
        }
       
      }
    }
  }
}
`

const ContentCategory = (props) => {
    const contentCategoryInfo = props.data.allPrismicContentCategoryLandingPage.edges[0].node;
    const documents = props.pageContext.documents;
    const pageTitle = contentCategoryInfo.data.content_category;
    let pageDescription = "";
    if(contentCategoryInfo.data.content_description != null){
      //pageDescription = RichText.asText(contentCategoryInfo.data.content_description.raw)
      pageDescription = prismicH.asText(contentCategoryInfo.data.content_description.raw)
    }
    else {
      pageDescription = pageTitle;
    }

    if(!documents) return null;

    const ItemsInCategory = ({docs}) => {
      if(docs.length > 50){
        return <ContentGrid documents={docs}/>
      }
      else
      {
        return <ItemsList items={docs}/>
      }
    }

    const ContentCategoryDescription = ({ pageDescription }) => {
      if(pageDescription === null || pageDescription.length === 0) return null
       return (

          <PrismicRichText field={pageDescription.raw}/> 
       )
    }

    if (typeof window !== "undefined"){
      return ( 
        <Layout>
        <SEO title={pageTitle} description={pageDescription} pathname={props.location.pathname}/>
        <Row>
          <Col lg={9} className="text-left">
              <h1>{contentCategoryInfo.data.content_category}</h1> 
              <div>
                <ContentCategoryDescription pageDescription={contentCategoryInfo.data.content_description}/>
              </div>
          </Col>
          <Col lg={3} className="text-lg-right pr-lg-3 pt-2 pt-lg-0">
            <OtherOptionsMenu isAllContent={false}/>
          </Col>
        </Row>
        <hr className="my-4"/>
        <Row>
          <Col>
          <ItemsInCategory docs={documents}/>
          </Col>
        </Row>
        </Layout>
      )
    }
    else {
      return null;
    }
}

export default ContentCategory;